import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import DropDown from '../../../../../components/Input/DropDown'
import ErrorMessageWithExclamation from '../../../../../components/UI/ErrorMessageWithExclamation'
import { Button, Checkbox } from '../../../../../components/UI'

import { addNewAvailabilities } from '../../../../../routing/fetchingfunction/user/user.action'
import { selectAvailableEventsNewCreated } from '../../../../../routing/fetchingfunction/user/user.reducer'

import { advanceOptions } from '../../../../../constants'

const AvailabilityBooking = ({
  advanceBookingErrors,
  onAdvanceErrorChange,
  advanceBooking,
  repeatWeekly,
  setAdvanceBooking,
  setRepeatWeekly,
}) => {
  const dispatch = useDispatch()

  const newCreatedEvents = useSelector(selectAvailableEventsNewCreated)

  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSave = () => {
    if (!advanceBooking) {
      return onAdvanceErrorChange('Please select a value')
    }

    setIsSubmitting(true)

    onAdvanceErrorChange(null)

    dispatch(
      addNewAvailabilities({
        availability_calendars: newCreatedEvents,
        calendar_settings: {
          repeat_weekly: repeatWeekly,
          advance_booking: advanceBooking,
        },
      })
    ).finally(() => {
      setIsSubmitting(false)
    })
  }

  const handleChangeRepeat = () => {
    setRepeatWeekly(!repeatWeekly)
  }

  return (
    <div className="mt-[20px] p-[32px] rounded-[10px] bg-[#FEEBDD]">
      <h5 className="text-base font-bold text-primary-100">Lesson Booking Settings</h5>

      <div className="w-full flex items-center mt-[24px]">
        <p className="text-sm font-medium text-primary-100 mr-[10px]">
          how far in advance can students book a class
        </p>

        <DropDown
          menuItems={advanceOptions}
          value={advanceBooking}
          setValue={setAdvanceBooking}
          placeholder="Select Advance"
          className="!h-[44px] !w-fit"
        />

        <Checkbox
          label="Repeat every week"
          className="ml-[14px]"
          labelClassName="text-base text-primary-100 font-normal"
          checked={repeatWeekly}
          onChange={handleChangeRepeat}
        />
      </div>

      {advanceBookingErrors && <ErrorMessageWithExclamation text={advanceBookingErrors} />}

      <Button
        className="min-w-[200px] mt-[24px] h-[44px] font-semibold text-base"
        onClick={handleSave}
        isLoading={isSubmitting}
      >
        Save
      </Button>
    </div>
  )
}

export default AvailabilityBooking
